var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757557925928,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4658,
    id: "mx_n_1757557925929",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.4 260.8h412c16.8 0 31.2-7.2 41.6-16.8 10.4-10.4 13.6-27.2 10.4-41.6L752 151.2a74.96 74.96 0 0 0-61.6-48h-55.2c-3.2 0-3.2 0-3.2-3.2L618.4 48a74.96 74.96 0 0 0-61.6-48H467.2c-27.2 0-55.2 16.8-61.6 44.8L392 96l-3.2 3.2h-55.2c-27.2 0-55.2 20.8-61.6 48l-13.6 51.2c-3.2 13.6 0 31.2 10.4 41.6 2.4 14.4 16 20.8 33.6 20.8z m24-99.2l3.2-3.2h55.2c27.2 0 55.2-20.8 61.6-44.8l13.6-51.2 4-4h89.6c3.2 0 3.2 0 3.2 3.2l13.6 51.2c7.2 27.2 34.4 48 61.6 48h55.2c3.2 0 3.2 0 3.2 3.2l10.4 41.6-388-3.2 13.6-40.8zM722.4 393.6L605.6 704l-310.4 116.8 116.8-310.4c-0.8-0.8 310.4-116.8 310.4-116.8zM552 662.4L453.6 564 388 728 552 662.4z",
    "p-id": 4659,
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M913.6 137.6H798.4v66.4h104v753.6H120V204h104v-66.4H108.8c-31.2 0-55.2 24-55.2 51.2v783.2c0 31.2 27.2 55.2 55.2 51.2h804.8c27.2 3.2 55.2-20.8 55.2-51.2V188.8c0-27.2-24-51.2-55.2-51.2z",
    "p-id": 4660,
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenGuide);
export default __webpack_public_path__ + "static/media/openGuide.1543ca7e4f97aacc6d1f023698390e26.svg";
export { ForwardRef as ReactComponent };